export interface NewsletterSubscriptionStatusResponse {
  isSubscribed: boolean;
}

export interface NewsletterSubscribeResponse {
  message: string;
}

export type NewsletterApiEventHandler = (args: {
  userId: number | null;
  userToken: string | null;
  newsletterId: string | null;
}) => Promise<boolean>;

// TODO: Should be moved to config
const NEWSLETTER_WIDGET_API_BASE_URL =
  'https://kundeportal.aftenposten.no/api/newsletter-widget';

const fetchNewsletterWidgetApi = async <NewsletterWidgetApiResponse>(
  path: string,
  sig: string,
  method: 'GET' | 'POST' = 'GET',
): Promise<NewsletterWidgetApiResponse> => {
  const options: RequestInit = {
    method,
    mode: 'cors',
    headers: {
      'x-score-spid-sig': sig,
    },
  };

  return fetch(`${NEWSLETTER_WIDGET_API_BASE_URL}/${path}`, options).then(
    (res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);

      return res.json();
    },
  );
};

export const subscribeNewsletter: NewsletterApiEventHandler = async ({
  userId,
  userToken,
  newsletterId,
}) => {
  if (!userToken) {
    return false;
  }

  return fetchNewsletterWidgetApi<NewsletterSubscribeResponse>(
    `${userId}/${newsletterId}`,
    userToken,
    'POST',
  )
    .then((res) => res.message === 'success')
    .catch(() => false);
};

export const unsubscribeNewsletter: NewsletterApiEventHandler = async ({
  userId,
  userToken,
  newsletterId,
}) => {
  if (!userToken) {
    return false;
  }

  return fetchNewsletterWidgetApi<NewsletterSubscribeResponse>(
    `${userId}/${newsletterId}/false`,
    userToken,
    'POST',
  )
    .then((res) => res.message === 'success')
    .catch(() => false);
};

export const getIsSubscribedToNewsletter: NewsletterApiEventHandler = async ({
  userId,
  userToken,
  newsletterId,
}) => {
  if (!userToken) {
    return false;
  }

  // Endpoint requires bogus eloqua id, hence "123" as second parameter
  return fetchNewsletterWidgetApi<NewsletterSubscriptionStatusResponse>(
    `${userId}/123/${newsletterId}`,
    userToken,
  )
    .then((res) => res.isSubscribed)
    .catch(() => false);
};
